import { addons } from '@storybook/manager-api';
import { buttonwoodTheme } from './buttonwoodTheme.ts';

addons.setConfig({
  theme: buttonwoodTheme,
});
